import { type CancelNextValue, cancelNextOptions, inMonths } from './cancelNext';
import { localDate } from './format';

// CancelNextChoice: Pflichtfrage bei jeder Absage – neuer Termin, später erneut anfragen (Datum, vorbelegt in 6 Monaten), kein
// Interesse oder weiter in der Akquise.
export function CancelNextChoice({
  value,
  laterDate,
  onChange,
}: {
  value: string | undefined;
  laterDate: string | undefined;
  onChange: (next: CancelNextValue, laterDate?: string) => void;
}) {
  const label = 'Wie geht es mit dem Lead weiter?';
  return (
    <div className="cancel-next">
      <p className="report-sub">{label}</p>
      <div className="choice-grid" role="group" aria-label={label} data-count={cancelNextOptions.length}>
        {cancelNextOptions.map((o) => (
          <button
            key={o.value}
            type="button"
            className={value === o.value ? 'choice active' : 'choice'}
            aria-pressed={value === o.value}
            onClick={() => onChange(o.value, o.value === 'LATER' ? laterDate || inMonths(6) : laterDate)}
          >
            <span>{o.label}</span>
            <small>{o.hint}</small>
          </button>
        ))}
      </div>
      {value === 'LATER' && (
        <label className="field narrow">
          <span>Erneut anfragen am</span>
          <input type="date" value={laterDate ?? ''} min={localDate()} onChange={(e) => onChange('LATER', e.target.value)} />
        </label>
      )}
    </div>
  );
}
